module.exports = __webpack_public_path__ + "media/big/default-learning-library-19ce7222.png";